import { Button } from 'components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from 'components/ui/dropdown-menu';
import { cn } from 'utils/cn';
import { AppButtonProps, buttonStyle } from './buttonStyle';
import ButtonIconSlot from './ButtonIconSlot';

export interface MenuButtonItem {
    label: string;
    onClick: () => void;
}

interface Props extends AppButtonProps {
    menuItems: MenuButtonItem[];
    /** Layer class for the menu's positioner, for a menu opened from inside a surface that sits above the default one. */
    menuPositionerClassName?: string;
    /** The trigger's edge the menu lines up with; its start edge unless given. */
    menuAlign?: 'start' | 'center' | 'end';
    /** Classes for the menu itself, such as a fixed width in place of its content's. */
    menuClassName?: string;
}

export default function MenuButton({
    menuItems,
    menuPositionerClassName,
    menuAlign,
    menuClassName,
    children,
    variant,
    color,
    size,
    className,
    startIcon,
    endIcon,
    ...buttonProps
}: Props) {
    return (
        <DropdownMenu>
            <DropdownMenuTrigger
                render={
                    <Button {...buttonProps} {...buttonStyle({ variant, color, size }, className)}>
                        {startIcon ? (
                            <ButtonIconSlot side="start" size={size}>
                                {startIcon}
                            </ButtonIconSlot>
                        ) : null}
                        {children}
                        {endIcon ? (
                            <ButtonIconSlot side="end" size={size}>
                                {endIcon}
                            </ButtonIconSlot>
                        ) : null}
                    </Button>
                }
            />
            <DropdownMenuContent
                align={menuAlign}
                className={cn('w-auto', menuClassName)}
                positionerClassName={menuPositionerClassName}
            >
                {menuItems.map((item) => (
                    <DropdownMenuItem key={item.label} onClick={item.onClick}>
                        {item.label}
                    </DropdownMenuItem>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
